import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import axios, { AxiosResponse } from "axios";
import ReactDOM, { unmountComponentAtNode } from "react-dom";
import { useParams } from "react-router-dom";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  createTheme,
  Divider,
  Fade,
  IconButton,
  Input,
  List,
  ListItem,
  ListItemText,
  Slider,
  Snackbar,
  TextField,
  ThemeProvider,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import {
  ChevronLeft,
  ChevronRight,
  PlaylistAddCheck,
  Edit,
  MultilineChart,
  MoreVert,
  Delete,
} from "@material-ui/icons";
import { appSettings } from "../../utils/endpoints";
import {
  CamposReporte,
  FiltroRepPlano2DTO,
} from "../../models/controlls.model";
import AutoCompleteC from "../../utils/controlls/AutoCompleteC";
import CalendarC from "../../utils/controlls/CalendarC";
import RangoAñosC from "../../utils/controlls/RangoAñosC";
import AutoCompleteLocalC from "../../utils/controlls/AutoComleteLocalC";
import ReporteLocal from "../../utils/controlls/ReporteLocal";
import AutoCompleteResponsive from "../../utils/controlls/AutoCompleteResponsive";
import PieContext from "../../PieContext";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import InteractiveTutorial from "interactive-tutorial";
// import "interactive-tutorial/build/styles.css";
import "./reportes.css";
import ModalGraficas from "../modal/ModalGraficas";
import SearchIcon from "@material-ui/icons/Search";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import InputC from "../../utils/controlls/InputC";
import ReporteLocalSentencias from "../../utils/controlls/ReporteLocalSentencias";

export default function Reportes({ tipo = "" }) {
  const param= useParams();
  //#region ConstcamposFiltros
  const { actualizaDataEstadistica, actualizaAñosSelect, actualizaFiltros } =
    useContext(PieContext);
  const [sizeWindow, setSizeWindow] = useState<{ alto: number; ancho: number }>(
    { alto: 0, ancho: 0 }
  );
  const [anchoNavBar, setAnchoNavBar] = useState(250);
  const [camposReporte, setCamposReporte] = useState<Array<CamposReporte>>([]);
  const [disabledButton, setDisabledButton] = useState(false);
  const [años, setAños] = useState<number[]>([
    new Date().getFullYear(),
    new Date().getFullYear(),
  ]);
  const [listYears, SetListYears] = useState<any[]>([]);
  const [campos, setCampos] = useState<string[]>([]);
  const [camposFiltros, setCamposFiltros] = useState<any>({});
  const [camposFiltrosBackup, setCamposFiltrosBackup] = useState<any>({});
  const [mostrar, setMostrar] = useState(false);
  const [altoDivFilCam, setAltoDivFilCam] = useState("60%");
  const [state, setState] = useState<{ open: boolean; message: string }>({
    open: false,
    message: "",
  });
  const [stateModal, setStateModal] = useState(false);
  const [openTooltip, setOpenTooltip] = useState(false);

  const [filtrosSeleccionados, setFiltrosSeleccionados] = useState("");
  const [expandDEstadisticos, setExpandDEstadisticos] = useState(false);
  const [expandSentencias, setExpandSentencias] = useState(false);
  const [API_URL, setApiURL] = useState("");
  const [API_Service, setApiService] = useState("");
  const [currentSizeMobile, setCurrentSizeMobile] = useState(0);
  const [lastRemoved, setLastRemoved] = useState("");

  const divCampos = document.getElementById(
    "divCamposFiltro"
  ) as HTMLDivElement;
  const salas = [
    { value: "SUP", texto: "SUP-Superior" },
    { value: "SG ", texto: "SG-Guadalajara" },
    { value: "SM ", texto: "SM-Monterrey" },
    { value: "SX ", texto: "SX-Xalapa" },
    { value: "ST", texto: "ST-Toluca" },
    { value: "SC ", texto: "SC-Central" },
    { value: "SRE", texto: "SRE-Regional Especializada" },
    { value: "SCM", texto: "SCM-Ciudad de México" },
  ];
  const medio = [
    {
      value: "PSC",
      texto: "PSC-PROCEDIMIENTO ESPECIAL SANCIONADOR DE ÓRGANO CENTRAL DEL INE",
    },
    {
      value: "PSD",
      texto:
        "PSD-PROCEDIMIENTO ESPECIAL SANCIONADOR DE ÓRGANO DISTRITAL DEL INE",
    },
    {
      value: "PSL",
      texto: "PSL-PROCEDIMIENTO ESPECIAL SANCIONADOR DE ÓRGANO LOCAL DEL INE",
    },
    { value: "RRV", texto: "RRV-RECURSO DE REVISIÓN" },
    { value: "RAP", texto: "RAP-RECURSO DE APELACIÓN" },
    { value: "JIN", texto: "JIN-JUICIO DE INCONFORMIDAD" },
    { value: "REC", texto: "REC-RECURSO DE RECONSIDERACIÓN" },
    { value: "JRC", texto: "JRC-JUICIO DE REVISIÓN CONSTITUCIONAL ELECTORAL" },
    {
      value: "JDC",
      texto:
        "JDC-JUICIO PARA LA PROTECCIÓN DE LOS DERECHOS POLÍTICO-ELECTORALES DEL CIUDADANO",
    },
    {
      value: "JLI",
      texto:
        "JLI-JUICIO PARA DIRIMIR LOS CONFLICTOS O DIFERENCIAS LABORALES DE LOS SERVIDORES DEL INSTITUTO NACIONAL ELECTORAL",
    },
    {
      value: "CLT",
      texto:
        "CLT-CONFLICTOS O DIFERENCIAS LABORALES ENTRE EL TEPJF Y SUS SERVIDORES",
    },
    {
      value: "ASA",
      texto: "ASA-APELACIÓN POR IMPOSICIÓN DE SANCIONES ADMINISTRATIVAS",
    },
    { value: "AES", texto: "AES-ASUNTOS ESPECIALES" },
    { value: "AG ", texto: "AG-ASUNTO GENERAL" },
    { value: "OP ", texto: "OP-OPINIÓN DE ACCIÓN  DE INCONSTITUCIONALIDAD" },
    { value: "CDC", texto: "CDC-CONTRADICCIÓN DE CRITERIOS" },
    {
      value: "REV",
      texto:
        "REV-RECURSO DE REVISIÓN EN MATERIA DE TRANSPARENCIA Y ACCESO A LA INFORMACIÓN",
    },
    {
      value: "RRT",
      texto: "RRT-RECURSO DE RECONSIDERACIÓN EN MATERIA DE TRANSPARENCIA",
    },
    {
      value: "SFA",
      texto:
        "SFA-SOLICITUD DE EJERCICIO DE LA FACULTAD DE ATRACCIÓN DE LA SALA SUPERIOR",
    },
    { value: "COM", texto: "COM-CONFLICTO COMPETENCIAL" },
    {
      value: "QRA",
      texto:
        "QRA-QUEJA POR RESPONSABILIDADES ADMINISTRATIVAS DE LOS SERVIDORES PÚBLICOS",
    },
    {
      value: "PRA",
      texto:
        "PRA-PROCEDIMIENTO DE RESPONSABILIDAD ADMINISTRATIVA DE LA PRESIDENCIA DEL TRIBUNAL ELECTORAL DEL PODER JUDICIAL DE LA FEDERACIÓN",
    },
    { value: "IMP", texto: "IMP-IMPEDIMENTO" },
    { value: "ELI", texto: "ELI-JUICIOS LABORALES" },
    { value: "INN", texto: "INN-INNOMINADO" },
    {
      value: "RDJ",
      texto: "RDJ-RATIFICACIÓN DE JURISPRUDENCIA PLANTEADA POR SALA REGIONAL",
    },
    { value: "EEP", texto: "EEP-EXPEDIENTE DE ELECCIÓN PRESIDENCIAL" },
    {
      value: "REP",
      texto: "REP-RECURSO DE REVISIÓN DEL PROCEDIMIENTO ESPECIAL SANCIONADOR",
    },
    {
      value: "RVT",
      texto: "RVT-RECURSO DE REVISIÓN EN MATERIA DE TRANSPARENCIA",
    },
    { value: "JE ", texto: "JE-JUICIO ELECTORAL" },
    { value: "ECE", texto: "ECE-EXPEDIENTE CALIFICACIÓN DE ELECCIÓN" },
    { value: "RIN", texto: "RIN-RECURSO DE INCONFORMIDAD" },
  ];

  const arraySiNo = [
    { value: "SI", texto: "SI" },
    { value: "NO", texto: "NO" },
  ];

  const entidades = [
    { value: "Aguascalientes", texto: "Aguascalientes" },
    { value: "Baja California", texto: "Baja California" },
    { value: "Baja California Sur", texto: "Baja California Sur" },
    { value: "Campeche", texto: "Campeche" },
    { value: "Chiapas", texto: "Chiapas" },
    { value: "Chihuahua", texto: "Chihuahua" },
    { value: "Ciudad de México", texto: "Ciudad de México" },
    { value: "Coahuila", texto: "Coahuila" },
    { value: "Colima", texto: "Colima" },
    { value: "Distrito Federal", texto: "Distrito Federal" },
    { value: "Durango", texto: "Durango" },
    { value: "Estado de México", texto: "Estado de México" },
    { value: "Federal", texto: "Federal" },
    { value: "Guanajuato", texto: "Guanajuato" },
    { value: "Guerrero", texto: "Guerrero" },
    { value: "Hidalgo", texto: "Hidalgo" },
    { value: "Jalisco", texto: "Jalisco" },
    { value: "Michoacán", texto: "Michoacán" },
    { value: "Morelos", texto: "Morelos" },
    { value: "Nayarit", texto: "Nayarit" },
    { value: "Nuevo León", texto: "Nuevo León" },
    { value: "Oaxaca", texto: "Oaxaca" },
    { value: "Puebla", texto: "Puebla" },
    { value: "Querétaro", texto: "Querétaro" },
    { value: "Quintana Roo", texto: "Quintana Roo" },
    { value: "San Luis Potosí", texto: "San Luis Potosí" },
    { value: "Sinaloa", texto: "Sinaloa" },
    { value: "Sonora", texto: "Sonora" },
    { value: "Tabasco", texto: "Tabasco" },
    { value: "Tamaulipas", texto: "Tamaulipas" },
    { value: "Tlaxcala", texto: "Tlaxcala" },
    { value: "Veracruz", texto: "Veracruz" },
    { value: "Yucatán", texto: "Yucatán" },
    { value: "Zacatecas", texto: "Zacatecas" },
  ];
  //#endregion Const

  //#region Effects

  useEffect(() => {
    ajustaSize();
    window.addEventListener("resize", ajustaSize);
    return () => {
      window.removeEventListener("resize", ajustaSize);
    };
  }, []);

  useEffect(() => {
    localStorage.setItem("deshabilita", "0");
    appSettings.then((res) => {
      setApiURL(res.API_URL);
      setApiService(res.EXPEDIENTES_CONSULTA);
    });
  }, []);

  useEffect(() => {
    if ([API_URL, API_Service].includes("")) return;

    const mobile = window.screen.width < 1000;

    const tutorial = async () => {
      localStorage.setItem("deshabilita", "1");
      await InteractiveTutorial({
        options: [
          {
            elementSelector: '[data-id="seccionAños"]',
            text: "Con esta barra podrás seleccionar un rango de años para consultar información.",
            preferredPosition: "bottom",
          },
          {
            elementSelector: mobile
              ? '[data-id="seccionVariablesMobile"]'
              : '[data-id="seccionVariables"]',
            text:
              "En esta sección encontrarás la lista de variables a consultar, " +
              `${
                mobile
                  ? "solo selecciona las variables."
                  : "solo arrastra la variable al recuadro derecho."
              }`,
            preferredPosition: `${mobile ? "bottom" : "right"}`,
          },
          {
            elementSelector: '[data-id="seccionArrastra"]',
            text: `A las variables ${
              mobile ? "seleccionadas" : "arrastadas a este recuadro"
            }, podrás aplicarle filtros para recuperar datos más específicos.`,
            preferredPosition: "top",
          },
        ],
        padding: 10,
        textOffsetX: 20,
        textOffsetY: 20,
      });

      sessionStorage.setItem("IntTutorial", "si");
    };

    DatosEstadisticos();
    if (!sessionStorage.getItem("IntTutorial")) {
      tutorial();
    }
  }, [API_URL, API_Service]);

  useEffect(() => {
    if (campos.length === 0)
      if (divCampos) ReactDOM.render(<></>, divCampos);
      else return;
    let backup = { ...camposFiltrosBackup };
    setCamposFiltrosBackup({});
    ReactDOM.render(
      campos.map((campo, idx) => {
        let oldValue: string[] = [];
        let campoSplited = campo.split("-")[0];
        if (
          Object.keys(backup).length > 0 &&
          backup[campoSplited] !== undefined
        ) {
          oldValue = [...backup[campoSplited].valor];
        }

        if (campo.indexOf("Fecha") !== -1) {
          return (
            <CalendarC
              key={`cal-${campo}-${idx}`}
              id={campo}
              años={años}
              filtro={false}
              filtros={camposFiltros}
              onlyMonth={false}
              previousValue={oldValue}
              nombreColumna={setNombreColumna(campo.split("-")[0]) || ""}
              eliminaInput={(idCampo: string, filtroInput: boolean) =>
                eliminaCampoImput(idCampo, filtroInput)
              }
              guardaSeleccion={(campo: string, filtro: FiltroRepPlano2DTO) =>
                guardarCampoFiltro(campo, filtro)
              }
            />
          );
        }

        if (
          [
            "Año del proceso electoral",
            "Año de recepción",
            "Año de resolución",
          ].includes(campo.split("-")[0])
        ) {
          return (
            <AutoCompleteLocalC
              key={`acl-${campo}-${idx}`}
              id={campo}
              filtro={false}
              filtros={camposFiltros}
              previousValue={oldValue}
              datos={listYears}
              nombreColumna={setNombreColumna(campo.split("-")[0]) || ""}
              eliminaInput={(idCampo: string, filtroInput: boolean) =>
                eliminaCampoImput(idCampo, filtroInput)
              }
              guardaSeleccion={(campo: string, filtro: FiltroRepPlano2DTO) => {
                console.log(filtro);
                guardarCampoFiltro(campo, filtro);
              }}
            />
          );
        }

        if (campo.indexOf("Año") !== -1) {
          // campo.split("-")[0] === 'Año') {
          return (
            <RangoAñosC
              key={`ra-${campo}-${idx}-${años[0] + años[1]}-${anchoNavBar}`}
              id={campo}
              años={años}
              filtro={false}
              filtros={camposFiltros}
              ancho={(sizeWindow.ancho - (anchoNavBar + 80)) / 2}
              onlySentence={filtrosSeleccionados === "Sentencias"}
              nombreColumna={setNombreColumna(campo.split("-")[0]) || ""}
              eliminaInput={(idCampo: string, filtroInput: boolean) =>
                eliminaCampoImput(idCampo, filtroInput)
              }
              guardaSeleccion={(campo: string, filtro: FiltroRepPlano2DTO) =>
                guardarCampoFiltro(campo, filtro)
              }
            />
          );
        }

        if (campo.substring(0, 3) === "Mes") {
          return (
            <CalendarC
              key={`cal-${campo}-${idx}`}
              id={campo}
              años={años}
              filtro={false}
              filtros={camposFiltros}
              onlyMonth={true}
              previousValue={oldValue}
              nombreColumna={setNombreColumna(campo.split("-")[0]) || ""}
              specificLabel={campo.split("-")[0]}
              eliminaInput={(idCampo: string, filtroInput: boolean) =>
                eliminaCampoImput(idCampo, filtroInput)
              }
              guardaSeleccion={(campo: string, filtro: FiltroRepPlano2DTO) =>
                guardarCampoFiltro(campo, filtro)
              }
            />
          );
        }
        //entidades
        if (["Sala", "Medio", "Entidad"].includes(campo.split("-")[0])) {
          return (
            <AutoCompleteLocalC
              key={`acl-${campo}-${idx}`}
              id={campo}
              filtro={false}
              filtros={camposFiltros}
              previousValue={oldValue}
              datos={
                campo.split("-")[0] === "Sala"
                  ? salas
                  : campo.split("-")[0] === "Entidad"
                  ? entidades
                  : medio
              }
              onlySentence={filtrosSeleccionados === "Sentencias"}
              nombreColumna={campo.split("-")[0]}
              error={() => {
                return (
                  validaSentencias() &&
                  filtrosSeleccionados === "DatosEstadisticos"
                );
              }}
              eliminaInput={(idCampo: string, filtroInput: boolean) =>
                eliminaCampoImput(idCampo, filtroInput)
              }
              guardaSeleccion={(campo: string, filtro: FiltroRepPlano2DTO) =>
                guardarCampoFiltro(campo, filtro)
              }
            />
          );
        }

        if (
          [
            "Vinculado con procesos electorales",
            "Usos y costumbres",
            "Inaplicación de una norma",
          ].includes(campo.split("-")[0])
        ) {
          return (
            <AutoCompleteLocalC
              key={`acl-${campo}-${idx}`}
              id={campo}
              filtro={false}
              filtros={camposFiltros}
              datos={arraySiNo}
              previousValue={oldValue}
              nombreColumna={setNombreColumna(campo.split("-")[0]) || ""}
              eliminaInput={(idCampo: string, filtroInput: boolean) =>
                eliminaCampoImput(idCampo, filtroInput)
              }
              guardaSeleccion={(campo: string, filtro: FiltroRepPlano2DTO) =>
                guardarCampoFiltro(campo, filtro)
              }
            />
          );
        }

        if (
          camposReporte[0].datosEstadisticos.find(
            (i) => i.alias === campo.split("-")[0]
          )?.nombreColumna === "BuscarSentencias"
        ) {
          return (
            <InputC
              key={`ac-${campo}-${idx}`}
              id={campo}
              filtro={false}
              filtros={camposFiltros}
              label={campo.split("-")[0]}
              onlySentence={filtrosSeleccionados === "Sentencias"}
              error={true}
              nombreColumna={setNombreColumna(campo.split("-")[0]) || ""}
              eliminaInput={(idCampo: string, filtroInput: boolean) =>
                eliminaCampoImput(idCampo, filtroInput)
              }
              guardaSeleccion={(campo: string, filtro: FiltroRepPlano2DTO) =>
                guardarCampoFiltro(campo, filtro)
              }
            />
          );
        }

        if (campo.split("-")[0] === "Consecutivo") {
          return (
            <InputC
              key={`ac-${campo}-${idx}`}
              id={campo}
              filtro={false}
              filtros={camposFiltros}
              type={"number"}
              label={campo.split("-")[0]}
              onlySentence={filtrosSeleccionados === "Sentencias"}
              nombreColumna={setNombreColumna(campo.split("-")[0]) || ""}
              eliminaInput={(idCampo: string, filtroInput: boolean) =>
                eliminaCampoImput(idCampo, filtroInput)
              }
              guardaSeleccion={(campo: string, filtro: FiltroRepPlano2DTO) =>
                guardarCampoFiltro(campo, filtro)
              }
            />
          );
        }

        return (
          <InputC
            key={`ac-${campo}-${idx}`}
            id={campo}
            filtro={false}
            filtros={camposFiltros}
            label={campo.split("-")[0]}
            nombreColumna={setNombreColumna(campo.split("-")[0]) || ""}
            eliminaInput={(idCampo: string, filtroInput: boolean) =>
              eliminaCampoImput(idCampo, filtroInput)
            }
            guardaSeleccion={(campo: string, filtro: FiltroRepPlano2DTO) =>
              guardarCampoFiltro(campo, filtro)
            }
          />
        );
      }),
      divCampos
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campos]);

  useEffect(() => {
    actualizaAñosSelect(años);
    let localListYears: number[] = [];
    if (años[0] === años[1])
      SetListYears([{ value: años[0].toString(), texto: años[0].toString() }]);
    else {
      let aux = [];
      for (let i = años[1]; i >= años[0]; i--)
        aux.push({ value: i.toString(), texto: i.toString() });
      SetListYears(aux);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [años]);

  useEffect(() => {
    actualizaFiltros(camposFiltros);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [camposFiltros]);
  useEffect(() => {
    setTimeout(() => {
      const elements = document.getElementsByClassName("MuiBox-root");
      const footer = document.getElementsByClassName("footerSection");  
        if (elements.length > 0 && param.tipo == "2")  {
          const parentElement = elements[0].parentElement;
          if (parentElement) {
            parentElement.style.display = "none";
          }
        }
        if (footer.length > 0 && param.tipo == "2") {
          const parentFooter = footer[0].parentElement;
          if (parentFooter) {
            parentFooter.style.display = "none";
          }
       
        }
    }, 50);

},[param])

  //#endregion Effects

  //#region Styles
  const styleDivCampos: CSSProperties = {
    height: sizeWindow.alto,
    width: anchoNavBar,
    backgroundColor: "#f9f5fa",
    overflow: "auto",
    transition: "width 1s",
    overflowX: "hidden",
  };

  const unExpandIconStyle: CSSProperties = {
    width: "auto",
    // padding: "10px 3px 10px",
    margin: "20px",
    color: "#24135f", //"#b1a252",
    transition: "width 1s",
    float: "right",
  };

  const styleDivContenedor: CSSProperties = {
    display: "flex",
    flexDirection: "row",
    height: sizeWindow.alto,
    width: sizeWindow.ancho - 15,
    overflow: "auto",
    backgroundColor: "#ffffff",
  };

  const styleDivReporteador: CSSProperties = {
    height: sizeWindow.alto,
    width: sizeWindow.ancho - anchoNavBar,
    overflow: "auto",
  };

  const styleDivFiltroAños: CSSProperties = {
    padding: "15px 15px 0px 15px",
  };

  const styleBoxAños: CSSProperties = {
    width: "97%",
  };

  const styleDivFiltrosCampos: CSSProperties = {
    display: "flex",
    flexDirection: "row",
    height: altoDivFilCam,
  };

  const styleDivDrag: CSSProperties = {
    width: sizeWindow.ancho - anchoNavBar - 15,
    height: "91%",
    textAlign: "center",
    border: "1px solid #b1a252",
    overflow: "auto",
    margin: "0 1px",
  };

  const CustomSlider = createTheme({
    overrides: {
      MuiSlider: {
        root: {
          color: "#24135f",
        },
        thumb: {
          height: 15,
          width: 15,
          backgroundColor: "#b1a252",
          border: "1px solid #b1a252",
          boxShadow: "#ebebeb 0 2px 2px",
          "&:focus, &:hover, &$active": {
            boxShadow: "#ccc 0 2px 3px 1px",
          },
          "& .bar": {
            // display: inline-block !important;
            height: 9,
            width: 1,
            backgroundColor: "currentColor",
            marginLeft: 1,
            marginRight: 1,
          },
        },
        active: {},
        track: {
          height: 3,
        },
        rail: {
          color: "#d8d8d8",
          opacity: 1,
          height: 3,
        },
      },
    },
  });
  //#endregion Styles

  //#region Services
  async function DatosEstadisticos() {
    let response = await axios.get(`${API_URL}/Estadistica/Estadisticas`);
    let data = response.data[0];
    data.datosEstadisticos = data.datosEstadisticos.filter(
      (i: any) => i.nombreColumna !== "FechaHoraRecepcion"
    );
    setCamposReporte([data]);
  }
  //#endregion Services

  //#region LocalFunction
  const ajustaSize = () => {
    let screenAlto = window.innerHeight;
    let screenAncho = window.innerWidth;

    let menu = document
      .getElementsByClassName("MuiBox-root")[0]
      .getBoundingClientRect().bottom;

    setSizeWindow({ alto: screenAlto - menu, ancho: screenAncho });
  };

  function marks(): any[] {
    let mark: any[] = [];

    const mobile = window.screen.width < 1000;
    if (!mobile) {
      mark = [
        { value: 1996, label: "1996" },
        { value: 2000, label: "2000" },
        { value: 2005, label: "2005" },
        { value: 2010, label: "2010" },
        { value: 2015, label: "2015" },
        { value: 2020, label: "2020" },
        {
          value: new Date().getFullYear(),
          label: new Date().getFullYear().toString(),
        },
      ];
    } else {
      mark = [
        { value: 1996, label: "1996" },
        { value: 2002, label: "2002" },
        { value: 2009, label: "2009" },
        { value: 2015, label: "2015" },
        {
          value: new Date().getFullYear(),
          label: new Date().getFullYear().toString(),
        },
      ];
    }
    return mark;
  }

  function guardarCampoFiltro(campo: string, filtro: FiltroRepPlano2DTO) {
    if (campo in camposFiltros) return;

    if (
      filtro.campo === lastRemoved.split("-")[0] ||
      lastRemoved.split("-")[0] in camposFiltros
    ) {
      delete camposFiltros[lastRemoved.split("-")[0]];
      return;
    }

    camposFiltros[campo] = filtro;
    for (const [key, value] of Object.entries(camposFiltros)) {
      camposFiltros[key]["nombreColumna"] =
        camposReporte[0].datosEstadisticos.find(
          (i) => i.alias === key
        )?.nombreColumna;
    }
    setCamposFiltros({ ...camposFiltros });
  }

  const setNombreColumna = (alias: string) => {
    return camposReporte[0].datosEstadisticos.find((i) => i.alias === alias)
      ?.nombreColumna;
  };

  function datosReportePlano() {
    let validaCamposMostrar: boolean = false;
    for (let campoM in camposFiltros) {
      if (camposFiltros[campoM].filtro === false) validaCamposMostrar = true;

      if (campoM.substring(0, 3) === "Mes") {
        if (
          camposFiltros[campoM].valor[0] === "" ||
          isNaN(camposFiltros[campoM].valor[0])
        ) {
          camposFiltros[campoM].valor = [];
          camposFiltros[campoM].operador = "";
        } else {
          camposFiltros[campoM].valor = [
            `${parseInt(camposFiltros[campoM].valor[0])}`,
          ];
          camposFiltros[campoM].operador = "igual a";
        }
      }
    }

    if (!mostrar && validaCamposMostrar) {
      if (validaCampos()) return;

      setMostrar(true);
      setAltoDivFilCam("50px");
      divCampos.style.display = "none";
      // setExpanded(false);
      setAnchoNavBar(50);
    } else if (!validaCamposMostrar) {
      setState({
        open: true,
        message: "Seleccionar campos para visualizar",
      });
    }
  }

  function limpiarFiltros(): void {
    if (filtrosSeleccionados === "") return;

    setMostrar(false);
    divCampos.style.display = "block";
    setAltoDivFilCam("60%");
    setAnchoNavBar(250);

    const mobile = window.screen.width < 1000;
    if (mobile) {
      setCampos([]);
      setCamposFiltros({});
      setAños([new Date().getFullYear(), new Date().getFullYear()]);
      setDisabledButton(false);
      setCurrentSizeMobile(0);
      return;
    }

    actualizaDataEstadistica([]);
    let datos = camposReporte.find((x) => x.idEstadistica.toString() === "2");
    if (datos) {
      if (filtrosSeleccionados === "Sentencias") {
        let aux = datos.datosEstadisticos.filter((i) =>
          i.apartado.includes(filtrosSeleccionados)
        )[0];

        let dato = aux.alias;
        let d = document.getElementById(dato.split("-")[0]) as HTMLElement;
        if (d) d.style.display = "block";
      } else {
        datos.datosEstadisticos
          .filter((i) => i.apartado.includes(filtrosSeleccionados))
          .forEach((datoParam) => {
            let dato = datoParam.alias;
            let d = document.getElementById(dato.split("-")[0]) as HTMLElement;
            if (d) d.style.display = "block";
          });
      }
    }

    setFiltrosSeleccionados("");
    unmountComponentAtNode(divCampos);
    setCampos([]);
    setCamposFiltros({});
    setAños([new Date().getFullYear(), new Date().getFullYear()]);
    setDisabledButton(false);
  }

  function validaSentencias(): boolean {
    let toValidate =
      camposReporte[0].datosEstadisticos.find(
        (i) => i.nombreColumna === "BuscarSentencias"
      )?.alias || "";

    return toValidate in camposFiltros;
  }

  function validaCampos(): boolean {
    let valida0 = false;
    let valueSearched = "";
    let masterKey = "";
    let campoToValidate = "";
    for (const [key, value] of Object.entries(camposFiltros)) {
      valida0 = camposFiltros[key]["nombreColumna"] === "BuscarSentencias";
      if (valida0) {
        campoToValidate = camposFiltros[key]["campo"];
        masterKey = camposFiltros[key]["nombreColumna"];
        valueSearched = camposFiltros[key]["valor"];
        break;
      }
    }
    if (
      valida0 &&
      (valueSearched.length === 0 || valueSearched[0].length < 4)
    ) {
      setState({
        open: true,
        message: "El texto a buscar debe tener mínimo 4 letras.",
      });
      return true;
    }

    if (filtrosSeleccionados === "Sentencias" || !valida0) return false;

    let valida: boolean = false;
    let message: string = "Los siguientes campos son requeridos: ";
    let keys: string[] = [campoToValidate, "Sala", "Medio", "Año"];

    keys.forEach((key) => {
      if (
        camposFiltros[key].valor.length === 0 ||
        camposFiltros[key].valor[0] === ""
      ) {
        valida = true;

        message +=
          message === "Los siguientes campos son requeridos: "
            ? key
            : `, ${key}`;
      }
    });

    setState({
      open: valida,
      message: message,
    });
    return valida;
  }

  function eliminaCampoImput(idCampo: string, filtroInput: boolean) {
    setCamposFiltrosBackup({ ...camposFiltros });

    setLastRemoved(idCampo);
    let filtrado = campos.filter((x) => x !== idCampo);
    setCampos(filtrado);
    if (filtrosSeleccionados !== "Sentencias") {
      let d = document.getElementById(idCampo.split("-")[0]);
      if (d) d.style.display = "block";
    }

    let camposF: any = {};
    for (let obj in camposFiltros) {
      if (obj !== idCampo.split("-")[0]) camposF[obj] = camposFiltros[obj];
    }
    setCamposFiltros(camposF);
    if (Object.keys(camposF).length === 0) setFiltrosSeleccionados("");
  }

  function editaCamposTabla() {
    setMostrar(false);
    actualizaDataEstadistica([]);
    setAltoDivFilCam("60%");
    divCampos.style.display = "block";
    setAnchoNavBar(250);
  }

  const generaExel = (csvData: any, fileName: string) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const hideShowElements = () => {
    // campos.forEach((v: any) => {
    //   if (v.split("-")[0] !== "Buscar en sentencias") {
    //     let d = document.getElementById(
    //       `${v.split("-")[0]}`
    //     ) as HTMLElement;
    //     if (d) d.style.display = value.indexOf(v) !== -1 ? "none" : "block";
    //   }
    // });
  };
  //#endregion LocalFunction

  //#region Handlers
  function handleChangeExpandNavBar() {
    if (anchoNavBar === 50) {
      setAnchoNavBar(250);
    } else {
      // setExpanded(false);
      setAnchoNavBar(50);
    }

    setOpenTooltip(false);
  }

  const handleChangeSlider = (event: any, newValue: number | number[]) => {
    setAños(newValue as number[]);
    setCampos([...campos]);
  };

  const handleCloseSnackbar = () => setState({ open: false, message: "" });
  //#endregion Handlers

  //#region Events
  const onDragStart =
    (key: string, nombreColumna: string, apartado: string) =>
    (event: React.DragEvent) => {
      //setLastRemoved("");
      //setFiltrosSeleccionados(apartado);

      event.dataTransfer.setData("Data", key);
      event.dataTransfer.setData("Type", nombreColumna);
      event.dataTransfer.setData("Apart", apartado);
    };

  const onDragOver = (event: React.DragEvent) => {
    event.preventDefault();
  };

  const onDrop = (area: string) => (event: React.DragEvent) => {
    debugger;
    let apart = event.dataTransfer.getData("Apart");
    setFiltrosSeleccionados(apart);
    if (apart === "DatosEstadisticos") {
      setExpandDEstadisticos(true);
      setExpandSentencias(false);
    } else {
      setExpandDEstadisticos(false);
      setExpandSentencias(true);
    }
    event.preventDefault();
    let key = event.dataTransfer.getData("Data");
    let type = event.dataTransfer.getData("Type");
    // en caso de seleccionar BuscarSentencias en datos estadísticos se jalaran por defecto los demás filtros
    if (type === "BuscarSentencias") {
      let keys: string[] = [key, "Sala-2", "Medio-2", "Consecutivo-2", "Año-2"];
      keys.forEach((ky) => {
        let filtroCampo: FiltroRepPlano2DTO = {
          campo: ky.split("-")[0],
          valor: [],
          operador: "",
          filtro: false,
          nombreColumna: "",
        };
        if (ky === "Consecutivo-2") filtroCampo.operador = "igual a";

        camposFiltros[ky.split("-")[0]] = filtroCampo;
        (
          document.getElementById(ky.split("-")[0]) as HTMLElement
        ).style.display = "none";
      });
      setCampos(keys);
      return;
    }

    let filtroCampo: FiltroRepPlano2DTO = {
      campo: key.split("-")[0],
      valor: [],
      operador: "",
      filtro: false,
      nombreColumna: "",
    };
    camposFiltros[key.split("-")[0]] = filtroCampo;

    (document.getElementById(key.split("-")[0]) as HTMLElement).style.display =
      "none";

    if (
      apart === "DatosEstadisticos" &&
      campos.length === 0 &&
      !key.includes("Expediente")
    ) {
      let filtroExpediente: FiltroRepPlano2DTO = {
        campo: "Expediente",
        valor: [],
        operador: "",
        filtro: false,
        nombreColumna: "",
      };
      camposFiltros["Expediente"] = filtroExpediente;

      (document.getElementById("Expediente") as HTMLElement).style.display =
        "none";

      setCampos([...campos, `Expediente-${key.split("-")[1]}`, key]);
      return;
    }

    setCampos([...campos, key]);
    // DefineColumnas([...campos, key]);
  };

  const onClickButtonCampos =
    (idEstadistica: string, apartado: string) => (event: React.MouseEvent) => {
      if (apartado === "DatosEstadisticos") {
        setExpandDEstadisticos(true);
        setExpandSentencias(false);
      } else {
        setExpandDEstadisticos(false);
        setExpandSentencias(true);
      }
      if (!disabledButton) {
        setDisabledButton(true);
        // setExpanded(false);
        // setAnchoNavBar(50);
        let datos = camposReporte.find(
          (x) => x.idEstadistica.toString() === idEstadistica.toString()
        );

        if (datos) {
          let acumula: string[] = [];
          datos.datosEstadisticos
            .filter((i) => i.apartado.split(",").includes(apartado))
            .forEach((datoParam) => {
              let dato = datoParam.alias;
              let d = document.getElementById(
                dato.split("-")[0]
              ) as HTMLElement;
              d.style.display = "none";
              if (campos.indexOf(`${dato}-${idEstadistica}`) === -1) {
                acumula.push(`${dato}-${idEstadistica}`);
                let filtroCampo: FiltroRepPlano2DTO = {
                  campo: dato,
                  valor: [],
                  operador: "igual a",
                  filtro: false,
                  nombreColumna: "",
                };
                camposFiltros[dato] = filtroCampo;
              }
            });
          setCampos([...campos, ...acumula]);
          setFiltrosSeleccionados(apartado);
        }
      } else {
        setDisabledButton(false);
        let datos = camposReporte.find(
          (x) => x.idEstadistica.toString() === idEstadistica.toString()
        );

        if (datos) {
          datos.datosEstadisticos
            .filter((i) => i.apartado.split(",").includes(apartado))
            .forEach((datoParam) => {
              let dato = datoParam.alias;
              let d = document.getElementById(
                dato.split("-")[0]
              ) as HTMLElement;
              d.style.display = "block";
            });

          unmountComponentAtNode(divCampos);
          setCampos([]);
          setCamposFiltros({});
          setFiltrosSeleccionados("");
        }
      }
    };

  const handleExpandDEstadisticos =
    () => (event: ChangeEvent<{}>, newExpanded: boolean) => {
      if (filtrosSeleccionados.length === 0) {
        setExpandDEstadisticos(newExpanded);
        setExpandSentencias(false);
        return;
      }
      if (filtrosSeleccionados === "DatosEstadisticos") {
        setExpandDEstadisticos(true);
        setExpandSentencias(false);
        return;
      }
    };

  const handleExpandSentencias =
    () => (event: ChangeEvent<{}>, newExpanded: boolean) => {
      if (filtrosSeleccionados.length === 0) {
        setExpandSentencias(newExpanded);
        setExpandDEstadisticos(false);
        return;
      }
      if (filtrosSeleccionados === "Sentencias") {
        setExpandDEstadisticos(false);
        setExpandSentencias(true);
        return;
      }
    };
  //#endregion Events

  return (
    <>
      <div
        className="autoCompleteCamposWrapper"
        data-id="seccionVariablesMobile"
      >
        <AutoCompleteResponsive
          collection={camposReporte[0]?.datosEstadisticos}
          parentCampos={campos}
          parentSetCampos={setCampos}
          parentFilterSelected={filtrosSeleccionados}
          parentSetFilterSelected={setFiltrosSeleccionados}
          parentLimpiarFiltros={limpiarFiltros}
          parentEliminaCampoImput={eliminaCampoImput}
          parentcurrentSize={currentSizeMobile}
        />
      </div>
      <div style={styleDivContenedor}>
        <div
          style={styleDivCampos}
          className="camposWrapper"
          data-id="seccionVariables"
        >
          {camposReporte.map((sistemas, idxS) => (
            <List
              style={{ overflowY: "auto", overflowX: "hidden" }}
              component="nav"
              aria-label="mailbox folders"
              dense={true}
              key={`lst-${idxS}`}
            >
              <ListItem
                button
                key={"btn" + sistemas.idEstadistica}
                id={"btn" + sistemas.idEstadistica}
                style={{
                  background: "#f9f5fa",
                  textAlign: "center",
                  height: "35px",
                }}
              >
                {anchoNavBar === 50 ? null : <div>Lista de filtros</div>}
                <span className={anchoNavBar === 50 ? "marginAdjust" : ""}>
                  <div
                    onMouseOver={() => setOpenTooltip(true)}
                    onMouseLeave={() => setOpenTooltip(false)}
                  >
                    <Tooltip
                      title={anchoNavBar === 50 ? "Expandir" : "Contraer"}
                      placement="right"
                      disableFocusListener
                      // disableTouchListener
                      open={openTooltip}
                    >
                      {anchoNavBar === 50 ? (
                        <ChevronRight
                          style={unExpandIconStyle}
                          onClick={handleChangeExpandNavBar}
                        />
                      ) : (
                        <ChevronLeft
                          style={unExpandIconStyle}
                          onClick={handleChangeExpandNavBar}
                        />
                      )}
                    </Tooltip>
                  </div>
                </span>
              </ListItem>
              <Accordion
                TransitionProps={{ unmountOnExit: true }}
                className={anchoNavBar === 50 ? "hiddenOption" : ""}
                style={{
                  background: "#f9f5fa",
                  borderColor: "#b1a252",
                  borderWidth: "0.25px",
                  borderStyle: "solid",
                }}
                expanded={expandDEstadisticos}
                onChange={handleExpandDEstadisticos()}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Datos estadísticos</Typography>
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    display: "block",
                  }}
                >
                  <Tooltip
                    key={`tb-${sistemas.idEstadistica}`}
                    title={
                      disabledButton
                        ? "Clic para quitar todos los campos"
                        : "Clic para incluir todos los campos"
                    }
                    className={anchoNavBar === 50 ? "hiddenOption" : ""}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      style={{
                        whiteSpace: "nowrap",
                        width: "100%",
                        minWidth: "auto",
                        backgroundColor: "rgba(255,255,255,0.06)",
                        color: "#24135f",
                        border: "0.5px solid #24135f",
                        backdropFilter: "blur(10px)",
                      }}
                      onClick={onClickButtonCampos(
                        sistemas.idEstadistica,
                        "DatosEstadisticos"
                      )}
                    >
                      {disabledButton ? "Quitar campos" : "Todos los campos"}
                    </Button>
                  </Tooltip>
                  {sistemas.datosEstadisticos
                    .filter((e) => e.apartado === "DatosEstadisticos")
                    .map((campo, idx) => (
                      <ListItem
                        button
                        key={campo.alias}
                        id={campo.alias}
                        style={{
                          background: "#f9f5fa",
                          borderColor: "#b1a252",
                          borderWidth: "0.25px",
                          borderStyle: "solid",
                        }}
                      >
                        <ListItemText
                          primary={campo.alias}
                          key={idx}
                          draggable="true"
                          onDragStart={onDragStart(
                            `${campo.alias}-${sistemas.idEstadistica}`,
                            campo.nombreColumna,
                            "DatosEstadisticos"
                          )}
                        />
                      </ListItem>
                    ))}
                </AccordionDetails>
              </Accordion>
              <Accordion
                TransitionProps={{ unmountOnExit: true }}
                className={anchoNavBar === 50 ? "hiddenOption" : ""}
                style={{
                  background: "#f9f5fa",
                  borderColor: "#b1a252",
                  borderWidth: "0.25px",
                  borderStyle: "solid",
                }}
                expanded={expandSentencias}
                onChange={handleExpandSentencias()}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Sentencias</Typography>
                </AccordionSummary>
                <AccordionDetails
                  style={{
                    display: "block",
                  }}
                >
                  {sistemas.datosEstadisticos
                    .filter((e) => e.apartado === "Sentencias")
                    .map((campo, idx) => (
                      <ListItem
                        button
                        key={campo.alias}
                        id={campo.alias}
                        style={
                          campo.nombreColumna === "BuscarSentencias"
                            ? {
                                background: "#f9f5fa",
                                borderColor: "#b1a252",
                                borderWidth: "0.25px",
                                borderStyle: "solid",
                              }
                            : {
                                background: "#f9f5fa",
                                borderColor: "#b1a252",
                                borderWidth: "0.25px",
                                borderStyle: "solid",
                                display: "none",
                              }
                        }
                      >
                        <ListItemText
                          primary={campo.alias}
                          key={idx}
                          draggable="true"
                          onDragStart={onDragStart(
                            `${campo.alias}-${sistemas.idEstadistica}`,
                            campo.nombreColumna,
                            "Sentencias"
                          )}
                        />
                      </ListItem>
                    ))}
                </AccordionDetails>
              </Accordion>
              <Divider />
            </List>
          ))}
        </div>
        <div
          id="divReporteador"
          style={styleDivReporteador}
          className="reporteadorWrapper"
        >
          <div id="filtroRep" style={styleDivFiltroAños} data-id="seccionAños">
            <Box sx={styleBoxAños}>
              <strong>
                <span>
                  Rango de años {años[0]}-{años[1]}
                </span>
              </strong>
              <ThemeProvider theme={CustomSlider}>
                <Slider
                  style={{}}
                  getAriaLabel={() => "Rango de años"}
                  value={años}
                  onChange={handleChangeSlider}
                  valueLabelDisplay="auto"
                  marks={marks()}
                  min={1996}
                  max={new Date().getFullYear()}
                  defaultValue={[
                    new Date().getFullYear(),
                    new Date().getFullYear(),
                  ]}
                />
              </ThemeProvider>
            </Box>
          </div>
          <div style={styleDivFiltrosCampos}>
            <div>
              {!mostrar ? (
                <Button
                  className="styleButtonRecuperarDatos"
                  type="submit"
                  variant="contained"
                  //color="success"
                  endIcon={<PlaylistAddCheck />}
                  size="small"
                  onClick={() => {
                    datosReportePlano();
                  }}
                  id="btnReportePlano"
                >
                  {"Recuperar datos"}
                </Button>
              ) : null}
              <Button
                className="styleButtonLimpiarTodo"
                type="submit"
                variant="contained"
                //color="primary"
                endIcon={<Delete />}
                size="small"
                onClick={() => {
                  limpiarFiltros();
                }}
                id="btnReportePlano"
              >
                {window.screen.width < 1000 && mostrar ? "" : "Limpiar todo"}
              </Button>
              {mostrar ? (
                <Button
                  className="styleButtonEditar"
                  type="submit"
                  variant="contained"
                  color="primary"
                  endIcon={<Edit />}
                  size="small"
                  onClick={() => {
                    editaCamposTabla();
                  }}
                  id="btnReportePlano"
                  disabled={false}
                >
                  {window.screen.width < 1000 && mostrar ? "" : "Editar"}
                </Button>
              ) : null}
              {mostrar && filtrosSeleccionados !== "Sentencias" ? (
                <Button
                  className="styleButtonGraficar"
                  variant="contained"
                  endIcon={<MultilineChart />}
                  size="small"
                  onClick={() => {
                    setStateModal(true);
                  }}
                  id="btnGrafica"
                >
                  {window.screen.width < 1000 && mostrar ? "" : "Graficar"}
                </Button>
              ) : null}
              <div
                style={styleDivDrag}
                onDrop={onDrop("divCampos")}
                onDragOver={onDragOver}
                id="divCamposFiltro"
                className="filtroContainer"
                data-id="seccionArrastra"
              ></div>
            </div>
          </div>
          {mostrar ? (
            filtrosSeleccionados === "Sentencias" ? (
              <ReporteLocalSentencias
                camposReporte={camposFiltros}
                alto={sizeWindow.alto - 50}
                generaExcel={(csvData: any, fileName: string) => {
                  generaExel(csvData, fileName);
                }}
              />
            ) : (
              <ReporteLocal
                camposReporte={camposFiltros}
                alto={sizeWindow.alto - 50}
                años={años}
                generaExcel={(csvData: any, fileName: string) => {
                  generaExel(csvData, fileName);
                }}
              />
            )
          ) : (
            <div
              id="fakeTable"
              style={{
                display: "flex",
                flexDirection: "row",
                overflow: "auto",
                padding: "10px 0px 0px 0px",
              }}
            >
              {campos.map((col: string, idx: number) => (
                <div
                  key={idx}
                  style={{
                    background: "#24135f",
                    color: "#FFFF",
                    borderColor: "#FFFF",
                    borderWidth: "0.25px",
                    borderStyle: "solid",
                    padding: "10px 20px 5px 20px",
                    width: "100vw - 10px",
                  }}
                >
                  <strong>{col.split("-")[0]}</strong>
                </div>
              ))}
            </div>
          )}
        </div>

        <Snackbar
          open={state.open}
          onClose={handleCloseSnackbar}
          TransitionComponent={Fade}
          message={state.message}
          key={"fade"}
        />
        {stateModal ? (
          <ModalGraficas cerrarModal={() => setStateModal(false)} />
        ) : null}
      </div>
    </>
  );
}
